import type { SVGProps } from 'react';

export const EyeSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 27.1949 16.9168"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="16.9168" opacity="0" width="27.1949" x="0" y="0" />{' '}
        <path
          d="M13.4199 16.9168C21.4266 16.9168 26.8336 10.4625 26.8336 8.46504C26.8336 6.46308 21.4185 0.0167966 13.4199 0.0167966C5.52949 0.0167966 0 6.46308 0 8.46504C0 10.4625 5.52149 16.9168 13.4199 16.9168ZM13.4199 15.0434C7.17245 15.0434 2.2117 9.82617 2.2117 8.46504C2.2117 7.32402 7.17245 1.89022 13.4199 1.89022C19.6434 1.89022 24.6219 7.32402 24.6219 8.46504C24.6219 9.82617 19.6434 15.0434 13.4199 15.0434ZM13.4217 13.7184C16.3383 13.7184 18.6928 11.3533 18.6928 8.44726C18.6928 5.53417 16.3383 3.17968 13.4217 3.17968C10.5068 3.17968 8.14257 5.53241 8.14257 8.44726C8.14257 11.3533 10.5068 13.7184 13.4217 13.7184ZM13.4182 10.1627C12.4773 10.1627 11.7195 9.39785 11.7195 8.45703C11.7195 7.5162 12.4773 6.75487 13.4182 6.75487C14.3643 6.75487 15.1238 7.5162 15.1238 8.45703C15.1238 9.39785 14.3643 10.1627 13.4182 10.1627Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
